<template>
  <div class="cover-uploader-wrapper" :class="wrapperClass">
    <div class="cover-uploader" :class="!previewImage ? 'no-cover-selected' : ''">
      <div v-if="previewImage" class="preview">
        <div class="cover-preview" :style="{ 'background-image': 'url(' + previewImage + ')'}" @click="onCoverPreview">
          <!-- <img :src="Config.SERVER + 'web/' + previewImage" /> -->
        </div>
        <div class="cover-actions">
          <div class="np-btn np-white edit-cover"  @click="triggerFileInput">
            <svg><use href="@/assets/images/icons/edit.svg#icon"></use></svg>
          </div>          
          <div class="np-btn np-white np-color-danger delete-cover" @click="onRemoveCover">
            <svg><use href="@/assets/images/icons/trash.svg#icon"></use></svg>
          </div>
        </div>
      </div>
      <div v-else class="placeholder" @click="triggerFileInput">
        <span>{{ placeholder ? placeholder : $t("UI.task.addCover") }}</span>
      </div>
      <input type="file" ref="fileInput" @change="onFileChange" accept="image/*" style="display: none" />
    </div>
  </div>
</template>
  
<script>
  import Config from '../../config.js'

  export default {
    name: "CoverUploader",
    props: {
      initialImage: {
        type: String,
        default: null,
      },
      wrapperClass: {
        type: String,
        default: ""
      },      
      updateCover: {
        type: Function,
        required: true,
      },
      removeCover: {
        type: Function,
        required: true,
      },
      previewCover: {
        type: Function,
        default: () => {}
      },
      placeholder: {
        type: String,
        default: ""
      }  
    },
    data() {
        return {
            Config,
            previewImage: this.initialImage ? Config.SERVER + 'web/' + this.initialImage : null
        }
    },
    methods: {
        onFileChange(event) {
            const file = event.target.files[0]
            if (file) {
                this.previewImage = URL.createObjectURL(file)
                this.$emit("file-selected", file)
                this.updateCover(file)
            }
        },
        async onRemoveCover() {
        	await this.removeCover()
        	this.$refs.fileInput.type = 'text'
        	this.$refs.fileInput.type = 'file'
        	this.previewImage = null
        },
        onCoverPreview() {
          if (this.initialImage) {
            this.previewCover(this.initialImage)
          }
        },
        triggerFileInput() {
            this.$refs.fileInput.click()
        },
    },
    watch: {
      initialImage(newImage) {
        if (newImage) {
        	this.previewImage = Config.SERVER + 'web/' + newImage
        } else {
        	this.previewImage = null
        }
      },
    },
  };
</script>
  
<style scoped>
  .cover-uploader {
    width: 100%;
    min-height: 155px;
    height: 155px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    transition: border-color 0.3s;
    border: 1px solid #E7EBEF;
  }
  .cover-uploader:hover {
    border-color: #888888;
  }
  .cover-uploader.no-cover-selected {
    border: 1px dashed #cccccc;    
    height: 32px;
  }
  .placeholder {
    background-color: transparent;
    color: #aaaaaa;
    font-size: 14px;
    text-align: center;
    cursor: pointer;
  }
  .preview {
    position: relative;
    display: flex;
    width: 100%;
    height: 100%;
  }
  .preview .cover-preview {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cover-preview img {
    max-height: 100%;
    height: 100%;
  }
  .cover-actions {
    position: absolute;
    display: flex;
    flex-direction: column;
    padding: 0 5px;
    top: 7px;
    right: 7px;
    bottom: 7px;
    justify-content: space-between;
  }
</style>
  